import React from 'react';

class GlobalHeader extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      mobile: false,
    };
  }

  render() {
    const toggleMobileMenu = () => {
      this.setState({ mobile: !this.state.mobile });
    };
    return (
      <nav id="global-header">
        <ul className="header">
          <li><a href="https://dyzio.co"><img src="https://static1.squarespace.com/static/ta/5891bf8f59cc682602b99910/16/assets/logo-white.svg" alt="Logo" /></a></li>
          <li className="flex-spacer" />
            <li className="mobile-hidden"><a href="https://dyzio.co/about"><p>About</p></a></li>
            <li className="mobile-hidden"><a href="https://dyzio.co/resources"><p>Free Resources</p></a></li>
            <li className="mobile-hidden"><a href="https://search.dyzio.co"><p>Influencer search <span className="beta">beta</span></p></a></li>
            <li className="mobile-hidden"><a href="https://dyzio.co/blog"><p>Blog</p></a></li>
          <li className="mobile-hidden">
            <a href="https://app.dyzio.co/login">
              <button>
                <p>Log In</p>
              </button>
            </a>
          </li>
          <li className="mobile-visible">
            <button id="mobile-menu-toggle" onClick={toggleMobileMenu}>
              <img src="https://static1.squarespace.com/static/ta/5891bf8f59cc682602b99910/16/assets/hamburger.svg" alt="menu" id="menu-toggle" />
            </button>
          </li>
        </ul>
        { this.state.mobile &&
          <ul className="mobile-menu">
            <li><a href="https://dyzio.co/about"><p>About</p></a></li>
            <li><a href="https://dyzio.co/resources"><p>Free Resources</p></a></li>
            <li><a href="https://search.dyzio.co"><p>Influencer search<span className="beta">beta</span></p></a></li>
            <li><a href="https://dyzio.co/blog"><p>Blog</p></a></li>
            <li><a href="https://app.dyzio.co/login"><p>Log In</p></a></li>
          </ul>
        }
      </nav>
    );
  }
}

export default GlobalHeader;



// WEBPACK FOOTER //
// ./src/components/header/index.js